import React from 'react';
import { Tree } from 'antd';
import {
  arrayOf, number, oneOfType, shape, string,
} from 'prop-types';

const CompaniesList = ({
  treeData = [],
}) => {
  const renderTitle = (node) => {
    if (node?.children?.length) {
      return <b>{node.title}</b>;
    }

    return node.title;
  };

  return (
    <div id="companies-list-top">
      <Tree
        defaultExpandAll
        selectable={false}
        treeData={treeData}
        titleRender={renderTitle}
      />
    </div>
  );
};

CompaniesList.propTypes = {
  treeData: arrayOf(shape({
    title: string,
    key: oneOfType([string, number]),
    children: arrayOf(shape({
      title: string,
      key: oneOfType([string, number]),
    })),
  })),
};

export default CompaniesList;
